var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.85 53.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.73,53.35a6.31,6.31,0,0,1-2.53-.53,6.19,6.19,0,0,1-3.77-5.76V38.27C26.87,37,17.6,37.93,7.87,48.05A4.57,4.57,0,0,1,.07,44.1C4.41,18.91,24.3,15,33.43,14.54V6.29A6.27,6.27,0,0,1,44,1.7L65.86,22.09a6.29,6.29,0,0,1,0,9.18L44,51.66A6.25,6.25,0,0,1,39.73,53.35ZM28.83,32.8a28.61,28.61,0,0,1,7.77,1.1l1.83.52V47.06a1.23,1.23,0,0,0,.76,1.17A1.24,1.24,0,0,0,40.58,48L62.45,27.61a1.29,1.29,0,0,0,0-1.87L40.58,5.36a1.27,1.27,0,0,0-2.15.93V19.53l-2.54,0c-7.82-.11-26.13,2-30.64,24.1C10,38.9,18.29,32.8,28.83,32.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b4745ca6d0daedabf9706b8b4e01dd78.svg";
export { ForwardRef as ReactComponent };